<template>
    <v-card
        elevation="0"
        outlined
        class="pa-4"
        min-height="465px"
        style="min-width: inherit; border-radius: 16px;"
    >   
        <v-row class="ma-0 d-flex justify-space-between">
            <p class="tblName ma-0" style="font-size: 16px;">{{ title }}</p>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        slot="activator"
                        class="botonHover"
                        icon
                        fab
                        dark
                        @click="abrirModal()"
                        small
                    >
                        <v-icon class="tamIconoBoton" color="#828282">more_vert</v-icon>
                    </v-btn>
                </template>
                <span>Desglose de información</span>
            </v-tooltip>
        </v-row>

       <!--  <div style="height: 400px;" class="d-flex align-center justify-center" v-if="(items.length == 0 ||  items[0].cantidad == 0)">
            <p class="subtxt" style="font-size: 20px;">No hay datos disponibles</p>
        </div> -->
        <!--grafico-->
        <v-row  class="ma-0 d-flex align-center justify-center">
            <v-chart ref="chart" :options="chartOptions" autoresize />
        </v-row>
       <!--  <v-row class="d-flex justify-center ma-0">
            <p class="txt">{{tituloTotal}} - {{ total }}</p>
        </v-row> -->

        <v-dialog v-model="dialog"  persistent max-width="700px" scrollable>
            <v-card class="borde-card overflow-x-hidden">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <h2 class="titleModal">{{ tituloModal }}</h2>
                    </div>
                </v-card-title>
                <PerfectScrollbar style="background: #fff" :options="{ suppressScrollX: true }">
                    <v-card-text class="px-0 pb-0">
                        <div cols="12" style="height: 400px;" class="d-flex align-center justify-center" v-if="(items.length == 0 ||  items[0].cantidad == 0)">
                            <p class="subtxt" style="font-size: 20px;">No hay datos disponibles</p>
                        </div>
                        <v-container v-else class="mt-5 px-5">
                            <div v-for="element in items" class="px-5">
                                <v-row class="ma-0 d-flex justify-space-between">
                                    <p class="txt" style="font-size: 18px;">{{ element.nombre_empresa }}</p>
                                    <p class="txt" style="font-size: 18px;">{{ element.cantidad }}</p>
                                </v-row>
                                <div v-for="item in element.sucursales">
                                    <v-row class="ma-0 d-flex justify-space-between">
                                        <p class="subtxt">{{ item.nombre_sucursal }}</p>
                                        <p class="subtxt">{{ item.cantidad }}</p>
                                    </v-row>
                                </div>
                            </div>
                        </v-container>
                    </v-card-text>
                </PerfectScrollbar>
                <v-card-actions class="d-flex justify-end card_accion">
                    <button class="btnCerrar" @click="dialog = false">Cerrar</button>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import ECharts from 'vue-echarts';
    import 'echarts/lib/chart/pie';
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/title';
import PerfectScrollbar from 'perfect-scrollbar';
    export default {
        components: {
            'v-chart': ECharts
        },
        props:{
            title:{
                required:true,
                default: "Titulo"
            },
            items:{
                required: true,
                default: []
            },
            tipo:{
                rerquired: true,
                type: 'contratos' | 'activos' | 'inactivos',
                default: 'contratos'
            }
        },
        data(){
            return{
                data:[],
                itemsEmpresas: [],
                itemsSucursales:[],
                chartOptions: null,
                total: 0,
                tituloModal: '',
                tituloTotal:'',
                text: '',
                dialog: false,
                hasData: false,

            }
        },
        methods: {
            logData(){
                console.log(this.items)
                if(this.items.length == 0 ||  this.items[0].cantidad == 0){
                    this.data.push({name: 'Total', value: 0})
                    this.hasData = false
                    this.total = 0
                    this.text = 'Total'
                }
                else{
                    this.hasData = true
                    if(this.items.length == 1){
                        this.data = this.items[0].sucursales.map((el) => ({name: el.nombre_sucursal, value: el.cantidad }))
                        this.items[0].sucursales.forEach((el) => {
                            this.total = this.total + el.cantidad
                        })
                    }
                    else if(this.items.length > 1){
                        this.data = this.items.map((el) => ({name: el.nombre_empresa, value: el.cantidad}))
                        this.items.forEach((el) => {
                            this.total = this.total + el.cantidad
                        })
                    }
                    if(this.tipo == 'contratos'){
                        this.tituloTotal = 'Total de contratos elaborados'
                        this.text = 'Contratos'
                    }else if(this.tipo == 'activos'){
                        this.tituloTotal = 'Total de empleados activos'
                        this.text = 'Empleados'
                    }else if(this.tipo == 'inactivos'){
                        this.tituloTotal = 'Total de empleados inactivos'
                        this.text = 'Empleados'
                    }
                }
                this.setChartOptions()
            },
            getRandomColor() {
            const letters = '0123456789ABCDEF';
            let color = '#';
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
            },
            setChartOptions() {
            const pieData = this.data.map(item => ({
                ...item,
                itemStyle: {
                color: this.hasData ?  '#1E2245' : '#c4c4c4',
                borderColor: '#fff',
                borderWidth: 3
                }
            }));

            this.chartOptions = {
                title: {
                text: this.total,
                subtext: this.text,
                left: 'center',
                top: '42%',
                textStyle: {
                    fontSize: 24,
                    fontWeight: 'normal',
                },
                subtextStyle:{
                    fontSize: 20
                }
                },
                tooltip: {
                trigger: 'item',
                formatter: '{b}: {c} ({d}%)'
                },
                series: [
                {
                    name: 'Data',
                    type: 'pie',
                    radius: ['50%', '70%'],
                    label: {
                        show: false
                    },
                    
                    labelLine: {
                    show: false
                    },
                    data: pieData
                }
                ]
            };
            },
            addMouseEvents() {
                this.$nextTick(() => {
                    const chart = this.$refs.chart.chart;
                    chart.on('mouseover', (params) => {
                    if (params.componentType === 'series') {
                        // console.log(params)
                        chart.setOption({
                        title: {
                            text: `${params.data.value}`,
                            subtext: `${this.text}`
                        }
                        });
                    }
                    });

                    chart.on('mouseout', () => {
                    chart.setOption({
                        title: {
                        text: this.total,
                        subtext: this.text
                        }
                    });
                    });
                });
            },
            abrirModal(){
                if(this.tipo == 'contratos'){
                    this.tituloModal = 'Desglose de contratos elaborados'
                }else if(this.tipo == 'activos'){
                    this.tituloModal = 'Desglose de empleados activos'
                }else if(this.tipo == 'inactivos'){
                    this. tituloModal = 'Desglose de empleados inactivos'
                }

                this.dialog = true
            }           
        },
        created() {
            this.logData();
        },
        mounted(){
            this.addMouseEvents();
        }
    }
</script>

<style scoped >
.txt{
    margin-bottom: 5px;
    font-size: 14px;
    color: #101C5A;
    font-weight: 500;
}
.subtxt{
    margin-bottom: 5px;
    font-size: 14px;
    color: #828282;
    font-weight: 500; 
}

</style>